<template>
  <div>
    <Navbar />
    <div class="bg-gradient-dust overflow-hidden nav-offset-spacing">
      <div class="standard-spacing standard-spacing-y">
        <div class="md:flex">
          <div class="md:w-1/2 static">
            <h1 class="heading-1">About</h1>
            <p class="mt-8 subheading">
              Based in Adelaide, Australia, Hoap was built by a dedicated team of experts who are determined to elevate
              wellbeing in every organisation. With the belief that wellbeing is the foundation to achieving and
              sustaining excellence, we set out to develop an evidence based platform that provides the tools and
              knowledge required for an organisation's talent and leaders to thrive.
            </p>
            <p class="mt-8 subheading">
              We've paired tried and tested technology developed by our sister company that works with elite sport
              teams, Lumin Sports, with the work of leading researchers in the fields of stress, recovery, wellbeing and
              performance optimisation to build a one-of-a kind platform that is leading the way in workplace wellbeing
              and performance.
            </p>
          </div>
          <div class="w-1/2 hidden md:block">
            <ArchImage
              src="https://dcctsvhz4yusz.cloudfront.net/96a3278e-3b67-4933-a09a-287d20c46bcf.jpg"
              large
              extraArch
              class="ml-auto" />
          </div>
        </div>
        <div class="standard-spacing-t">
          <div class="md:flex">
            <div class="w-1/2 hidden md:block">
              <ArchImage
                src="https://dcctsvhz4yusz.cloudfront.net/cf4c859b-f54c-4ab5-b845-ecde0287d5ae.png"
                large
                class="mr-auto" />
            </div>
            <div class="md:w-1/2 ml-auto flex flex-col justify-between items-center">
              <p class="mt-8 md:mt-24 subheading text-center">
                Together, our team is committed to embedding wellbeing into the professional and personal lives of as
                many people as possible.
              </p>
              <div class="hidden md:flex items-center justify-end">
                <HoapIcon icon="ArrowDown" class="h-12 md:h-24 lg:h-48 mt-8 md:mt-16 mx-auto" />
              </div>
            </div>
          </div>
        </div>

        <div class="standard-spacing-t">
          <h2 class="heading-1 text-center">Our Mission</h2>
          <p class="mt-8 text-center subheading">
            Hoap exists to provide effective physical, mental and emotional performance tools for people of today, to
            ensure that they are their best selves tomorrow. Software designed for leading organisations, Hoap is
            pioneering Performance Wellbeing for teams of all sizes. Hoap is the first platform to quantify wellbeing
            for leaders and educate everyone to be their best selves.
          </p>
        </div>
        <img v-lazy="'/img/about/hoap-icon.png'" class="w-24 md:w-48 mx-auto mt-8" />
        <div class="standard-spacing-t">
          <People title="Humans of Hoap" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  setMetadata({ pageTitle: 'About' })
</script>
